import { type ReactNode } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import IconButton from 'LuxKit/Button/IconButton'
import LineTimesIcon from 'LuxKit/Icons/line/LineTimesIcon'
import Heading from 'LuxKit/Typography/Heading'
import { tierGradientBackgroundStyle, tierNormalContrastColorStyle } from 'styles/utils/tierStyles'

const GradientHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${rem(12)};
  padding: ${rem(32)} ${rem(28)};
  border-start-start-radius: ${props => props.theme.borderRadius.M};
  border-start-end-radius: ${props => props.theme.borderRadius.M};
  ${tierGradientBackgroundStyle}
  ${tierNormalContrastColorStyle}
`

const CloseButton = styled(IconButton)`
  && {
    color: inherit;
  }
`

interface Props {
  tier: App.LoyaltyTier
  title: ReactNode
  onClose: () => void
  dismissible?: boolean
}

function LoyaltyRewardChoiceGradientHeader({ tier, title, onClose, dismissible = true }: Props) {
  const intl = useIntl()
  const closeLabel = intl.formatMessage({
    id: 'WYXh_8yLMKajGJmG4XY0',
    defaultMessage: 'close',
    description: 'Aria label for close button in modal header dialog window',
  })

  return <GradientHeader className={`tier-${tier}`}>
    <Heading variant="heading3">{title}</Heading>
    {dismissible && <CloseButton
      kind="tertiary"
      variant="default"
      size="small"
      onClick={onClose}
      aria-label={closeLabel}
    >
      <LineTimesIcon />
    </CloseButton>}
  </GradientHeader>
}

export default LoyaltyRewardChoiceGradientHeader
